<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [phoneNumber]="phoneNumber"
  [heroImage]="heroImage"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage">
  
  <div class="content-section">
    <h2>Parc Informatique - Bris de Machine - Télécom - Engins</h2>
    <p>
      L'objet de ce contrat est de garantir les dommages accidentels survenus aux matériels et installations dans l'exercice de l'entreprise (casse, 
      brusque construction, fourneaux, aux matériels informatiques bousiers, à la destruction d'un fonctionnement anormal, à la construction de 
      l'œuvre ou à la production, d'usage et de fonctionnement exceptionnels).
    </p>
    <p>
      Le courtier en Assurance BROKINS est partenaire de nombreux assureurs, dont un échantillon est listé ci-après : 
      <strong>GENERALI, AXA, PROGEAS, HELVETIA</strong>.
    </p>
    <p>
      Le contrat d'assurance Bris de Machine est souvent déclinable lorsque le contrat d'<a href="#">Assurance Multirisque Professionnelle</a>, 
      ce n'est pas assurer le savoir-du ou beaucoup de votre matériel.
    </p>
  </div>

  <div class="content-section bg-accent">
    <h2 class="section-title-purple">GARANTIES DU CONTRAT :</h2>
    
    <h3>Une garantie commune à toutes les versions du contrat d'<a href="#">Assurance Pertes d'Exploitation</a> avec bris de matériels ou de matériels informatiques.</h3>
    <p><strong>Pour le contrat Bris de Machine - Matériels - Équipements, Installations Techniques</strong></p>
    <ul class="simple-list">
      <li>Dommages d'origine électrique,</li>
      <li>Chute d'objets,</li>
      <li>Vol - Installation,</li>
      <li>Incendie, Interne et externes,</li>
      <li>Négligence, fautes, imprudences ou fautes,</li>
      <li>Défaut de conception,</li>
      <li>Coût d'Exploitation après bris de machines sur contrats matériels,</li>
      <li>Tous dégâts montage cours,</li>
      <li>Tous dégâts montage essais (à la même heure de l'assurément montage),</li>
      <li>Frais supplémentaires.</li>
    </ul>

    <p><strong>Pour le contrat Bris de Machine - Informatique</strong></p>
    <ul class="simple-list">
      <li>Dommages électriques,</li>
      <li>Vol - Installation,</li>
      <li>Négligence, fautes, imprudence,</li>
      <li>Défaut de conception,</li>
      <li>Frais de déplacement d'un spécialiste suite à sinistre,</li>
      <li>Catastrophes naturelles.</li>
    </ul>

    <p><strong>Pour le contrat Bris de Machine - Engins Roulants</strong></p>
    <ul class="simple-list">
      <li>Collision, renversement, déchirement, écrits, affaissement, éboulement,</li>
      <li>Maladresse, manipulations,</li>
      <li>Maladresse, négligence, immatétance,</li>
      <li>Transport à l'extérieur, Congestion, déchargement,</li>
      <li>Défaut de matière ou vice de construction,</li>
      <li>Frais supplémentaires.</li>
    </ul>

    <p><strong>Pour le contrat Bris de Machine - Photovoltaïque - Installations centrales Mécaniques</strong></p>
    <ul class="simple-list">
      <li>Bris fonctionnel,</li>
      <li>Dommages électriques,</li>
      <li>Dégâts des eaux,</li>
      <li>Chute d'objets, chute de neige,</li>
      <li>Installation,</li>
      <li>Vol, tentative de vol, vandalisme,</li>
      <li>Catastrophes naturelles,</li>
      <li>Tous événements accidentels non-indiqués de la valeur totale de l'équipement,</li>
      <li>Installation : frais impact dossier dont dommages aux contrats et responsabilité civile de droits d'énergie,</li>
      <li>Perplès,</li>
      <li>Couverture automatique la période d'immobilisation serraille,</li>
      <li>Frais supplémentaires engagés pour limiter la perte.</li>
    </ul>
  </div>

  <div class="content-section">
    <h2 class="section-title-purple">FAMILLE DE MATÉRIELS CONCERNÉS :</h2>
    
    <p><strong>Pour le contrat Bris de Machine - Matériels - Équipements, Installations Techniques</strong></p>
    <ul class="simple-list">
      <li>Traité des notices (différence, transeus,</li>
      <li>Presses de platines d'armor à injectées),</li>
      <li>Compresseurs sous pression, réfrigérants,</li>
      <li>Pompes, postes de relevage,</li>
      <li>Production de localie (laiterie, réchauffé),</li>
      <li>Alimentation (four, brûleurs),</li>
      <li>Matériels, Equipements (matériels de test),</li>
      <li>Station-service, garage (spéciale de lavage, equilibres),</li>
      <li>...</li>
    </ul>

    <p><strong>Pour le contrat Bris de Machine - Informatique</strong></p>
    <ul class="simple-list">
      <li>Audiovisual (piècement collectivité, salarié),</li>
      <li>Communication (centrale téléphonique),</li>
      <li>Médical (Medical linkners, radiologie),</li>
      <li>Photocopiateurs (footostore, polyvalente),</li>
      <li>Traité de l'information (services, ordres inopérateds),</li>
      <li>Terminaux Bancaireiden (prix, télépaiement, transferts vidéographes),</li>
      <li>...</li>
    </ul>

    <p><strong>Pour le contrat Bris de Machine -Engins Roulants</strong></p>
    <ul class="simple-list">
      <li>Agricoles (semi-fauchit, épandroù)...,</li>
      <li>Levage (manipulation jour châsisou, grue)...,</li>
      <li>Manutention (carrés, transathlors, matériel) ...,</li>
      <li>Fabrication et transport de matériaux (bétonneur)...,</li>
      <li>Caravanes, louange, marcha (longue, convenios) ...,</li>
      <li>Transport ou personne (carette)...,</li>
      <li>Autorail-forte, perceuses (appareil, essort rouleuse)...,</li>
      <li>...</li>
    </ul>

    <p><strong>Pour le contrat Bris de Machine - Photovoltaïque -Installations centrales climatiques (fenêtres décornés) :</strong></p>
    <ul class="simple-list">
      <li>Panneaux et équipements électriques connexes</li>
    </ul>
  </div>

  <div class="content-section bg-light">
    <h2 class="section-title-purple">MONTANT DES CAPITAUX GARANTIS :</h2>
    <p>De 400 $ à 100 000 000 € de maximum agricole par contrat</p>
  </div>

  <div class="content-section">
    <h2 class="section-title-purple">LES EXCLUSIONS FREQUENTES :</h2>
    <ul class="simple-list">
      <li>Consommables (ampoex, turbines, tubes, exores, ),</li>
      <li>Dommages d'ordre esthétique (ligneurs, ),</li>
      <li>Dommages survenant à un équipement lorsque survient travail les érosage accidenté peut être pris en accident d'lieu ou un préemptoire d'électrique),</li>
      <li>Tous le matériel dont le valeur unitaire est inférieure à 450 €,</li>
      <li>Les objets et frais visas de la construction à son Dommage électrique gestion,</li>
      <li>Les frais d'usage ou de maintenance courante,</li>
      <li>Les composants électroniques lorsqu'il usait d'un seul élément électrogrophile (aux dommage accidenté peut être pris en accident d'lieu ou en préemptoire d'électrique),</li>
      <li>Pneumatiques,</li>
      <li>Aux équipements non assurables (brochante, outils, mesures,</li>
      <li>Entérites, marchandises, stocks (,</li>
      <li>Dommages d'ordre esthétique (impact),</li>
      <li>Dommages indirect à vit end élément préjuratifier, meubles, guides).</li>
    </ul>
  </div>

  <div class="content-section bg-accent">
    <h2 class="section-title-purple">ÉLÉMENTS À DÉCLARER POUR S'ASSURER :</h2>
    <p>Pour le matériel électronique :</p>
    <ul class="simple-list">
      <li>Valabeler médicalement :</li>
      <li>Type, modèle,</li>
      <li>Marques, portables :</li>
      <li>Résultats valeurs locales globale et factualisable</li>
      <li>N° de série :</li>
      <li>Répartition d'adresses :</li>
      <li>Marque,</li>
      <li>Année,</li>
      <li>Heures - Documents.</li>
      <li>N° de série,</li>
      <li>Valeur d'achat d'achat (galllitic),</li>
      <li>Valeur de replacement à neuf globalement système.</li>
    </ul>
  </div>
</app-page-layout>
